import { useState, type ChangeEvent, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Button, Field } from '../components/kit';
import { Brand } from '../components/Brand';
import { useAuth } from '../auth/AuthContext';
import { useBranding } from '../branding/BrandingProvider';
import { ApiRequestError } from '../api/client';
import './auth.css';

export function Register() {
  const { register } = useAuth();
  const { branding } = useBranding();
  const [form, setForm] = useState({
    fullName: '',
    companyName: '',
    email: '',
    phone: '',
    taxNumber: '',
    password: '',
  });
  const [error, setError] = useState<string | null>(null);
  const [fields, setFields] = useState<Record<string, string[]>>({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k: keyof typeof form) => (e: ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setFields({});
    setBusy(true);
    try {
      await register(form);
      setDone(true);
    } catch (err) {
      if (err instanceof ApiRequestError) {
        setError(err.message);
        if (err.fields) setFields(err.fields);
      } else {
        setError('Kayıt oluşturulamadı');
      }
    } finally {
      setBusy(false);
    }
  };

  const fe = (k: string) => fields[k]?.[0];

  return (
    <div className="auth-wrap">
      <div className="auth-card wide">
        <aside className="auth-aside">
          <Brand variant="auth" />
          <div className="auth-aside-tag">Tahsilat ve ödeme süreçlerinizi kolaylaştıran akıllı çözüm.</div>
          <div className="auth-aside-copy">© 2026 {branding.appName}. Tüm hakları saklıdır.</div>
        </aside>
        <div className="auth-main">
        {done ? (
          <div className="auth-done">
            <div className="auth-done-ico">✓</div>
            <h1>Kaydınız alındı</h1>
            <p className="auth-sub">
              Hesabınız <strong>yönetici onayı</strong> bekliyor. Onaylandıktan sonra e-posta/şifrenizle giriş
              yapabilirsiniz.
            </p>
            <Link className="btn btn-primary auth-submit" to="/giris">Giriş ekranına dön</Link>
          </div>
        ) : (
        <>
        <h1>Bayi kaydı</h1>
        <p className="auth-sub">Firma bilgilerinizle kayıt olun; yönetici onayından sonra giriş yapabilirsiniz.</p>
        <form className="auth-form" onSubmit={onSubmit}>
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-grid2">
            <div>
              <Field label="Ad Soyad" id="fullName" value={form.fullName} onChange={set('fullName')} required />
              {fe('fullName') && <div className="field-error">{fe('fullName')}</div>}
            </div>
            <div>
              <Field label="Firma Adı" id="companyName" value={form.companyName} onChange={set('companyName')} required />
              {fe('companyName') && <div className="field-error">{fe('companyName')}</div>}
            </div>
          </div>
          <div className="auth-grid2">
            <div>
              <Field label="Telefon" id="phone" value={form.phone} onChange={set('phone')} />
            </div>
            <div>
              <Field label="Vergi No" id="taxNumber" value={form.taxNumber} onChange={set('taxNumber')} />
            </div>
          </div>
          <div>
            <Field label="E-posta" id="email" type="email" autoComplete="email" value={form.email} onChange={set('email')} required />
            {fe('email') && <div className="field-error">{fe('email')}</div>}
          </div>
          <div>
            <Field label="Şifre (en az 8 karakter)" id="password" type="password" autoComplete="new-password" value={form.password} onChange={set('password')} required />
            {fe('password') && <div className="field-error">{fe('password')}</div>}
          </div>
          <Button className="auth-submit" type="submit" disabled={busy}>
            {busy ? 'Kayıt oluşturuluyor…' : 'Kayıt ol'}
          </Button>
        </form>
        <div className="auth-foot">
          Zaten hesabınız var mı? <Link to="/giris">Giriş yapın</Link>
        </div>
        </>
        )}
        </div>
      </div>
    </div>
  );
}
